import { AppointmentTypeEnum } from 'graphql/generated/remote-schema-hasura';
import { MyAppointmentDeets } from '../MyAppointmentDeets';
import { useEffect } from 'react';
import { useAppointmentTimer } from '../../../../hooks/useGetUpcomingAppointment';

interface AppointmentNotStartedProps {
  locale: Record<string, Record<string, string>>;
  appointmentType: AppointmentTypeEnum;
  providerName?: string | null;
  patientName?: string | null;
  title?: string | null;
  appointmentStartsAt: number;
  onAppointmentStart?: () => void;
  profileImage?: string | null;
  appointmentStartDate?: string;
  appointmentEndDate?: string;
}

export const AppointmentNotStarted: React.FC<AppointmentNotStartedProps> = ({
  locale,
  appointmentType,
  providerName = null,
  patientName = null,
  title = null,
  appointmentStartsAt,
  onAppointmentStart,
  appointmentStartDate,
  appointmentEndDate,
  profileImage,
}) => {
  const { time, isNotStarted } = useAppointmentTimer(
    appointmentStartDate,
    appointmentEndDate,
  );

  useEffect(() => {
    if (!isNotStarted) {
      onAppointmentStart && onAppointmentStart();
    }
  }, [isNotStarted, onAppointmentStart]);

  return (
    <>
      <div className="w-full h-full flex flex-col items-center justify-center gap-[60px]">
        <div className="flex flex-col items-center gap-2">
          <div className="text-h1 font-medium text-dark-gray mb-9 text-center">
            {locale?.consultation?.welcome}
          </div>
          <div className="text-h6 font-normal text-med-gray">
            {locale?.consultation?.start}
          </div>
          <div className="flex flex-row gap-16">
            <div className="flex flex-col">
              <div className="flex justify-center text-h1 font-medium text-dark-gray">
                {time?.hours?.toString().padStart(2, '0')}
              </div>
              <div className="text-h7 font-bold text-med-gray">
                {locale?.consultation?.hours.toUpperCase()}
              </div>
            </div>
            <div className="flex flex-col">
              <div className="flex justify-center text-h1 font-medium text-dark-gray">
                {time?.minutes?.toString().padStart(2, '0')}
              </div>
              <div className="text-h7 font-bold text-med-gray">
                {locale?.consultation?.minutes.toUpperCase()}
              </div>
            </div>
            <div className="flex flex-col">
              <div className="flex justify-center text-h1 font-medium text-dark-gray">
                {time?.seconds?.toString().padStart(2, '0')}
              </div>
              <div className="text-h7 font-bold text-med-gray">
                {locale?.consultation?.seconds.toUpperCase()}
              </div>
            </div>
          </div>
        </div>
        <MyAppointmentDeets
          appointmentType={appointmentType}
          date={new Date(appointmentStartsAt).toISOString()}
          fullName={(providerName || patientName) as string}
          title={title}
          isProvider={Boolean(providerName)}
          profileImage={profileImage}
        />
      </div>
    </>
  );
};
